import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    monthly: [],
    employeeReport: null,
    policy: null,
    daily: null,
};

const mutations = {
    setMonthly: (state, r) => (state.monthly = r),
    setEmployeeReport: (state, r) => (state.employeeReport = r),
    setPolicy: (state, r) => (state.policy = r),
    setDaily: (state, r) => (state.daily = r),
};

// Each getDaily call takes a number; a response that is no longer the latest (a slow
// automatic refresh overtaken by a change of date or department) is dropped.
let dailyRequest = 0;

const buildParams = params =>
    Object.entries(params)
        .filter(([, val]) => val !== null && val !== undefined && val !== "")
        .map(([key, val]) => `${key}=${val}`)
        .join("&");

const actions = {
    async getMonthly({ commit }, params) {
        try {
            commit("setMonthly", []);
            startLoading()
            const response = await dataService.attendanceReports.getMonthly(buildParams(params));
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setMonthly", response.data.report);
            commit("setPolicy", response.data.policy);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    // silent: the automatic refresh of today's sheet, without the page-wide loading overlay
    // and without clearing what is on screen while it loads.
    async getDaily({ commit }, { params, silent = false }) {
        const request = ++dailyRequest;
        try {
            if (!silent) {
                commit("setDaily", null);
                startLoading()
            }
            const response = await dataService.attendanceReports.getDaily(buildParams(params), silent);
            if (!silent) stopLoading()
            if (request !== dailyRequest) return;

            if (!response.data.statusCode) {
                if (!silent) showAlert(serverErrorMessage);
                return;
            }

            commit("setDaily", response.data);
            commit("setPolicy", response.data.policy);
        } catch (error) {
            if (!silent) {
                stopLoading()
                if (request === dailyRequest) catchHandler(error);
            }
        }
    },
    async getEmployee({ commit }, params) {
        try {
            commit("setEmployeeReport", null);
            startLoading()
            const response = await dataService.attendanceReports.getEmployee(buildParams(params));
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeReport", response.data);
            commit("setPolicy", response.data.policy);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
